module.exports = __webpack_public_path__ + "mi-c7cb450b86111e362d18.png";